// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import Header from "../components/header";
// import { apiurl } from "../config/config";
// import heic2any from "heic2any";

// const documentList = [
//   { key: "passportSizePhotos", label: "Passport Size Photo" },
//   //   { key: "signedEmployeeAgreement", label: "Signed Employee Agreement" },
// //   { key: "declarationGoodHealth", label: "Declaration of Good Health" },
//   //   { key: "residenceProof", label: "Residence Proof" },
//   { key: "appointmentOfferLetter", label: "Previous Appointment / Offer Letter" },
//   { key: "bankStatement", label: "Bank Statement" },
//   { key: "panCard", label: "PAN Card" },
//   //   { key: "resume", label: "Resume / CV" },
//   //   { key: "photo", label: "Personal Photo" },
//   // { key: "aadharCard", label: "Aadhar Card" },
//   { key: "aadharCardFront", label: "Aadhar Card Front" },
//   { key: "aadharCardBack", label: "Aadhar Card Back" },
//   //   { key: "passport", label: "Passport" },
//   { key: "cancelledChequeOrPassbook", label: "Cancelled Cheque / Passbook" },
// ];

// const EmployeeDocumentUpload = () => {
//   const { employeeToken } = useParams(); // employeeToken from URL
//   const navigate = useNavigate();

//   const [documents, setDocuments] = useState({});
//   const [employeeDetails, setEmployeeDetails] = useState();
//   const [uploadingKey, setUploadingKey] = useState("");
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchEmployeeDocs = async () => {
//       try {
//         const { data } = await axios.post(
//           `${apiurl}/api/employee/get-details/${employeeToken}`
//         );
//         setEmployeeDetails(data?.employee);

//         if (data?.employee?.documents) {
//           setDocuments(data.employee.documents);
//         }
//       } catch (err) {
//         console.error("Error fetching employee:", err);
//         alert("Invalid or expired link.");
//       }
//     };

//     fetchEmployeeDocs();
//   }, [employeeToken]);

//   console.log("documents", documents);
//   console.log("employeeDetails", employeeDetails);

//   //   const handleFileUpload = async (e, docKey) => {
//   //     const file = e.target.files[0];
//   //     if (!file) return;

//   //     setUploadingKey(docKey);

//   //     const formData = new FormData();
//   //     formData.append("file", file);
//   //     // formData.append("folder", "employee-documents");
//   //     formData.append("folder", `${employeeDetails?.identification?.aadharNumber}` || "employee-documents");

//   //     try {
//   //       const response = await axios.post(`${apiurl}/api/media/employeeFileUpload`, formData, {
//   //         headers: { "Content-Type": "multipart/form-data" },
//   //         timeout: 60000
//   //       });

//   //       if (response?.data?.success) {
//   //         setDocuments((prev) => ({
//   //           ...prev,
//   //           [docKey]: { link: response.data.fileUrl, uploaded: true }
//   //         }));
//   //       } else {
//   //         alert("Upload failed. Please try again.");
//   //       }
//   //     } catch (error) {
//   //         console.error("Full error object:", JSON.stringify(error, null, 2));
//   //         if (error.response) {
//   //           console.error("Error Response Data:", error.response.data);
//   //           console.error("Status Code:", error.response.status);
//   //           console.error("Headers:", error.response.headers);
//   //           alert(`Upload failed: ${error.response.data?.message || JSON.stringify(error.response.data)}`);
//   //           setError(`Server responded: ${error.response.data?.message || JSON.stringify(error.response.data)}`);
//   //         } else if (error.request) {
//   //           console.error("No response from server:", error.request);
//   //           alert("No response from server. Check your network or server.");
//   //           setError("No response from server. Network or server error.");
//   //         } else {
//   //           console.error("Error Setting up Request:", error.message);
//   //           alert(`Error: ${error.message}`);
//   //           setError(`Error: ${error.message}`);
//   //         }
//   //     } finally {
//   //       setUploadingKey("");
//   //     }
//   //   };

//   const handleFileUpload = async (e, docKey) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     let finalFile = file;

//     if (file.type === "image/heic" || file.name.endsWith(".heic")) {
//       try {
//         const convertedBlob = await heic2any({
//           blob: file,
//           toType: "image/jpeg",
//           quality: 0.9,
//         });
//         finalFile = new File(
//           [convertedBlob],
//           file.name.replace(/\.heic$/, ".jpg"),
//           { type: "image/jpeg" }
//         );
//       } catch (conversionError) {
//         setError("Error converting HEIC file.");
//         alert("Could not convert HEIC image to JPG. Please try another file.");
//         return;
//       }
//     }

//     const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
//     if (!allowedTypes.includes(finalFile.type)) {
//       setError(
//         `Unsupported file type: ${finalFile.type}. Please upload JPG, PNG, or PDF.`
//       );
//       alert(
//         `Unsupported file type: ${finalFile.type}. Please upload JPG, PNG, or PDF.`
//       );
//       return;
//     }

//     setUploadingKey(docKey);

//     const formData = new FormData();
//     formData.append("file", finalFile);
//     formData.append(
//       "folder",
//       `${employeeDetails?.identification?.aadharNumber}` || "employee-documents"
//     );

//     try {
//       const response = await axios.post(
//         `${apiurl}/api/media/employeeFileUpload`,
//         formData,
//         {
//           headers: { "Content-Type": "multipart/form-data" },
//           timeout: 60000,
//         }
//       );

//       if (response?.data?.success) {
//         setDocuments((prev) => ({
//           ...prev,
//           [docKey]: { link: response.data.fileUrl, uploaded: true },
//         }));
//       } else {
//         alert("Upload failed. Please try again.");
//       }
//     } catch (error) {
//       console.error("Full error:", JSON.stringify(error, null, 2));
//       if (error.response) {
//         setError(
//           `Server responded: ${
//             error.response.data?.message || JSON.stringify(error.response.data)
//           }`
//         );
//       } else if (error.request) {
//         setError("No response from server. Network or server error.");
//       } else {
//         setError(`Error: ${error.message}`);
//       }
//       alert(error.message);
//     } finally {
//       setUploadingKey("");
//     }
//   };

//   // const handleFileUpload = async (e, docKey) => {
//   //     const file = e.target.files[0];
//   //     if (!file) return;

//   //     const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
//   //     if (!allowedTypes.includes(file.type)) {
//   //       setError(`Unsupported file type: ${file.type}. Please upload JPG, PNG, or PDF.`);
//   //       alert(`Unsupported file type: ${file.type}. Please upload JPG, PNG, or PDF.`);
//   //       return;
//   //     }

//   //     setUploadingKey(docKey);
//   //     const formData = new FormData();
//   //     formData.append("file", file);
//   //     formData.append("folder", `${employeeDetails?.identification?.aadharNumber}` || "employee-documents");

//   //     try {
//   //       const response = await axios.post(`${apiurl}/api/media/employeeFileUpload`, formData, {
//   //         headers: { "Content-Type": "multipart/form-data" },
//   //         timeout: 60000
//   //       });

//   //       if (response?.data?.success) {
//   //         setDocuments((prev) => ({
//   //           ...prev,
//   //           [docKey]: { link: response.data.fileUrl, uploaded: true }
//   //         }));
//   //       } else {
//   //         alert("Upload failed. Please try again.");
//   //       }
//   //     } catch (error) {
//   //       console.error("Full error:", JSON.stringify(error, null, 2));
//   //       if (error.response) {
//   //         console.error("Error Response Data:", error.response.data);
//   //         alert(`Upload failed: ${error.response.data?.message || JSON.stringify(error.response.data)}`);
//   //         setError(`Server responded: ${error.response.data?.message || JSON.stringify(error.response.data)}`);
//   //       } else if (error.request) {
//   //         console.error("No response from server:", error.request);
//   //         alert("No response from server. Check your network or server.");
//   //         setError("No response from server. Network or server error.");
//   //       } else {
//   //         console.error("Error Setting up Request:", error.message);
//   //         alert(`Error: ${error.message}`);
//   //         setError(`Error: ${error.message}`);
//   //       }
//   //     } finally {
//   //       setUploadingKey("");
//   //     }
//   //   };

//   const handleRemoveFile = (docKey) => {
//     setDocuments((prev) => ({
//       ...prev,
//       [docKey]: { link: null, uploaded: false },
//     }));
//   };

//   const handleSubmit = async (e) => {
//     console.log("documents", documents);
//     e.preventDefault();
//     try {
//       await axios.post(
//         `${apiurl}/api/employee/updateEmployeeDetailsByToken/${employeeToken}`,
//         { documents }
//       );
//       alert("Documents submitted successfully!");
//       // navigate(`/employees/thankyou/${employeeToken}`);
//       navigate(`/employees/thankyou/${employeeToken}`);
//       // navigate(`/employees/thankyou/${employeeToken}/${employeeDetails?.employeeId}`);
//     } catch (error) {
//       console.error("Submit failed:", error);
//       alert("Submission failed. Try again.");
//     }
//   };

//   return (
//     <>
//       <Header title="Employee Document Upload" />
//       <div className="max-w-3xl mx-auto p-6 bg-white shadow-xl rounded-2xl mt-10">
//         <h2 className="text-2xl font-bold text-center mb-6">
//           Upload Your Documents
//         </h2>

//         {error && (
//           <div className="bg-red-100 text-red-800 p-2 rounded mt-2">
//             {error}
//           </div>
//         )}

//         <form onSubmit={handleSubmit}>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             {documentList.map(({ key, label }) => (
//               <div
//                 key={key}
//                 className="border rounded-xl p-4 flex flex-col gap-2 shadow-sm"
//               >
//                 <label className="font-medium text-gray-700">{label}</label>

//                 {documents[key]?.uploaded ? (
//                   <div className="flex justify-between items-center bg-green-100 text-green-700 p-2 rounded">
//                     <a
//                       href={documents[key].link}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="underline text-sm truncate"
//                     >
//                       View Uploaded File
//                     </a>
//                     <button
//                       type="button"
//                       className="text-red-500 text-sm hover:underline"
//                       onClick={() => handleRemoveFile(key)}
//                     >
//                       Remove
//                     </button>
//                   </div>
//                 ) : (
//                   <>
//                     <input
//                       type="file"
//                       //   accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
//                       accept="image/jpeg,image/png,application/pdf"
//                       onChange={(e) => handleFileUpload(e, key)}
//                       className="border rounded p-2 w-full text-sm"
//                     />
//                     {uploadingKey === key && (
//                       <div>
//                         <p>Uploading...</p>
//                         <div className="w-full bg-gray-200 rounded-full h-2">
//                           <div
//                             className="bg-blue-500 h-2 rounded-full"
//                             style={{
//                               width: `${documents[key]?.progress || 0}%`,
//                             }}
//                           />
//                         </div>
//                       </div>
//                     )}
//                   </>
//                 )}
//               </div>
//             ))}
//           </div>

//           <button
//             type="submit"
//             onClick={handleSubmit}
//             // disabled={Object.values(documents).some((doc) => !doc.uploaded)}
//             className="mt-8 bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-xl w-full font-semibold"
//           >
//             Submit Documents
//           </button>
//         </form>
//       </div>
//     </>
//   );
// };

// export default EmployeeDocumentUpload;
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../components/header";
import { apiurl } from "../config/config";
import heic2any from "heic2any";

/* ================= DOCUMENT CONFIG ================= */

const documentList = [
  { key: "passportSizePhotos", label: "Passport Size Photo" },
  { key: "appointmentOfferLetter", label: "Previous Appointment / Offer Letter" },
  { key: "bankStatement", label: "Bank Statement" },
  { key: "panCard", label: "PAN Card" },
  { key: "aadharCardFront", label: "Aadhar Card Front" },
  { key: "aadharCardBack", label: "Aadhar Card Back" },
  { key: "cancelledChequeOrPassbook", label: "Cancelled Cheque / Passbook" },
];

const educationLevels = [
  { name: "12th-Equivalent", mandatory: true },
  { name: "Highest Educational Certificate", mandatory: false },
];

/* ================= COMPONENT ================= */

const EmployeeDocumentUpload = () => {
  const { employeeToken } = useParams();
  const navigate = useNavigate();

  /* ================= STATE ================= */

  const [documents, setDocuments] = useState(
    documentList.reduce((acc, d) => {
      acc[d.key] = { link: null, uploaded: false };
      return acc;
    }, {})
  );

  const [educationDocs, setEducationDocs] = useState(
    educationLevels.map((edu) => ({
      name: edu.name,
      link: null,
      uploaded: false,
      verificationStatus: "pending",
      verificationRemarks: "",
    }))
  );

  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [uploadingKey, setUploadingKey] = useState("");
  const [error, setError] = useState("");

  /* ================= FETCH EMPLOYEE ================= */

  useEffect(() => {
    const fetchEmployeeDocs = async () => {
      try {
        const { data } = await axios.post(
          `${apiurl}/api/employee/get-details/${employeeToken}`
        );

        setEmployeeDetails(data?.employee);

        if (data?.employee?.documents) {
          setDocuments(data.employee.documents);
        }

        if (data?.employee?.educationalCertificates?.length) {
          setEducationDocs(data.employee.educationalCertificates);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        alert("Invalid or expired link.");
      }
    };

    fetchEmployeeDocs();
  }, [employeeToken]);

  /* ================= NORMAL DOC UPLOAD ================= */

  const handleFileUpload = async (e, docKey) => {
    const file = e.target.files[0];
    if (!file) return;

    let finalFile = file;

    if (file.type === "image/heic" || file.name.endsWith(".heic")) {
      try {
        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.9,
        });
        finalFile = new File(
          [convertedBlob],
          file.name.replace(/\.heic$/, ".jpg"),
          { type: "image/jpeg" }
        );
      } catch {
        alert("HEIC conversion failed");
        return;
      }
    }

    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
    if (!allowedTypes.includes(finalFile.type)) {
      alert("Only JPG, PNG or PDF allowed");
      return;
    }

    setUploadingKey(docKey);

    try {
      const formData = new FormData();
      formData.append("file", finalFile);
      formData.append(
        "folder",
        employeeDetails?.identification?.aadharNumber || "employee-documents"
      );

      const res = await axios.post(
        `${apiurl}/api/media/employeeFileUpload`,
        formData,
        { timeout: 60000 }
      );

      if (res?.data?.success) {
        setDocuments((prev) => ({
          ...prev,
          [docKey]: { link: res.data.fileUrl, uploaded: true },
        }));
      }
    } catch (err) {
      console.error(err);
      setError("Upload failed");
    } finally {
      setUploadingKey("");
    }
  };

  const handleRemoveFile = (docKey) => {
    setDocuments((prev) => ({
      ...prev,
      [docKey]: { link: null, uploaded: false },
    }));
  };

  /* ================= EDUCATION UPLOAD ================= */

  const handleEducationUpload = async (e, eduName) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG, PNG or PDF allowed");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append(
        "folder",
        employeeDetails?.identification?.aadharNumber || "education"
      );

      const res = await axios.post(
        `${apiurl}/api/media/employeeFileUpload`,
        formData
      );

      setEducationDocs((prev) =>
        prev.map((doc) =>
          doc.name === eduName
            ? { ...doc, link: res.data.fileUrl, uploaded: true }
            : doc
        )
      );
    } catch (err) {
      console.error(err);
      alert("Education upload failed");
    }
  };

  /* ================= SUBMIT ================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(
        `${apiurl}/api/employee/updateEmployeeDetailsByToken/${employeeToken}`,
        {
          documents,
          educationalCertificates: educationDocs,
        }
      );

      alert("Documents submitted successfully!");
      navigate(`/employees/thankyou/${employeeToken}`);
    } catch (err) {
      console.error(err);
      alert("Submission failed");
    }
  };

  /* ================= UI ================= */

  return (
    <>
      <Header title="Employee Document Upload" />

      <div className="max-w-3xl mx-auto p-6 bg-white shadow-xl rounded-2xl mt-10">
        <h2 className="text-2xl font-bold text-center mb-6">
          Upload Your Documents
        </h2>

        {error && (
          <div className="bg-red-100 text-red-800 p-2 rounded mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {documentList.map(({ key, label }) => (
              <div key={key} className="border rounded-xl p-4 shadow-sm">
                <label className="font-medium">{label}</label>

                {documents[key]?.uploaded ? (
                  <div className="flex justify-between bg-green-100 p-2 rounded mt-2">
                    <a
                      href={documents[key].link}
                      target="_blank"
                      rel="noreferrer"
                      className="underline text-sm"
                    >
                      View
                    </a>
                    <button
                      type="button"
                      onClick={() => handleRemoveFile(key)}
                      className="text-red-500 text-sm"
                    >
                      Remove
                    </button>
                  </div>
                ) : (
                  <input
                    type="file"
                    accept="image/jpeg,image/png,application/pdf"
                    onChange={(e) => handleFileUpload(e, key)}
                    className="mt-2"
                  />
                )}

                {uploadingKey === key && <p>Uploading...</p>}
              </div>
            ))}
          </div>

          <h3 className="text-lg font-bold mt-6">
            Educational Certificates
          </h3>

          {educationLevels.map((edu) => {
            const doc = educationDocs.find((d) => d.name === edu.name);

            return (
              <div key={edu.name} className="border p-4 rounded mt-3">
                <label className="font-semibold">
                  {edu.name}
                  {edu.mandatory && <span className="text-red-500"> *</span>}
                </label>

                {doc?.uploaded ? (
                  <a
                    href={doc.link}
                    target="_blank"
                    rel="noreferrer"
                    className="block text-green-600 underline mt-1"
                  >
                    View Uploaded
                  </a>
                ) : (
                  <input
                    type="file"
                    required={edu.mandatory}
                    accept="image/jpeg,image/png,application/pdf"
                    onChange={(e) =>
                      handleEducationUpload(e, edu.name)
                    }
                    className="mt-2"
                  />
                )}
              </div>
            );
          })}

          <button
            type="submit"
            className="mt-8 bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-xl w-full font-semibold"
          >
            Submit Documents
          </button>
        </form>
      </div>
    </>
  );
};

export default EmployeeDocumentUpload;